import { I18n } from '@calendly/i18n';
import { CheckboxInput } from '@calendly/ui/components/checkbox-input';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { STATUSES } from '../constants';
const wrapperIsSmallPhoneCss = "w11wvrb2";
const wrapperCss = "w13jl9lw";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const statusWrapperIsSmallPhoneCss = "s11gmou9";
const statusWrapperCss = "s1eppuy8";
const StatusWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <Component ref={ref} {...restProps} className={classNames(statusWrapperCss, {
    [statusWrapperIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const checkboxLabelCss = "cwwtkha";
const CheckboxLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(checkboxLabelCss, props.className)} />;
});
const labelCss = "l167y4wr";
const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});

// i18n-tasks-use t('publisher.scheduling.shared.statuses.created')
// i18n-tasks-use t('publisher.scheduling.shared.statuses.booked')
// i18n-tasks-use t('publisher.scheduling.shared.statuses.expired')

export const StatusFilter = ({
  value,
  onChange
}) => <Wrapper>
    <Label>
      {I18n.t('publisher.dashboard.filters.status')}
    </Label>
    <StatusWrapper>
      {STATUSES.map(status => <CheckboxLabel key={status}>
          <CheckboxInput key={status} checked={value.includes(status)} onChange={event => onChange(event.target.checked, status)} spacingRight="8" />
          {I18n.t(`publisher.scheduling.shared.statuses.${status}`)}
        </CheckboxLabel>)}
    </StatusWrapper>
  </Wrapper>;

require("./status_filter.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./status_filter.js");